module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-base-shadow-11.e27eeaee.png";